import { Fragment } from "react";
import { updateByCodigo } from "../../api/sorteo";
import { Form, Input, message, Button } from "antd";
// import { useHistory } from "react-router-dom";

function SortearModalPublicar({ closeModal, codigo, setRecordSorteo }) {
  // const history = useHistory();

  const onFinish = (values) => {
    sendDataToServer(values);
  };

  const sendDataToServer = async (data) => {
    data.isActivo = true; // para que lo publique
    try {
      const response = await updateByCodigo(data, codigo);
      if (response.success) {
        setRecordSorteo(response.payload);
        console.log(response);
        message.success("Sorteo publicado satisfactoriamente");
      }
    } catch (err) {
      message.error(err.message);
    } finally {
      closeModal();
    }
  };

  // ----- render -----
  return (
    <Fragment>
      <Form onFinish={onFinish} layout="vertical">
        <Form.Item
          label="Nombre de sorteo"
          name="nombre"
          rules={[
            {
              required: true,
              message: "El nombre del sorteo es necesario"
            }
          ]}
        >
          <Input className="text-xl" />
        </Form.Item>

        <div className="w-full flex gap-4 justify-end">
          <Button type="primary" htmlType="submit">
            Publicar
          </Button>

          <Button type="default" onClick={() => closeModal()}>
            Cancelar
          </Button>
        </div>
      </Form>
    </Fragment>
  );
}
export default SortearModalPublicar;
